// Methods for UI interactions const refreshDevices = async () => { // Try to
refresh from API first const refreshedFromAPI = await refreshDevicesFromAPI();
if (!refreshedFromAPI) { // Fallback to local storage refresh const stats =
DeviceStorageService.getStorageStats(); const result = await
NotificationService.confirm( `Saat ini terdapat ${stats.deviceCount} perangkat
dalam penyimpanan lokal.\n\nApakah Anda ingin memuat ulang data dari
penyimpanan?`, "Refresh Data Perangkat", "Ya, Muat Ulang", "Batal" ); if
(result.isConfirmed) { loading.value = true; try { // Reload devices from
storage devices.value = DeviceStorageService.loadDevices(); currentPage.value =
1; await NotificationService.success( `Data perangkat berhas
<template>
  <div class="card">
    <div class="card-header border-0 pt-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label fw-bold fs-3 mb-1">Perangkat IoT Walet</span>
        <span class="text-muted mt-1 fw-semobold fs-7"
          >Kelola, pantau &amp; tonton siaran langsung perangkat IoT walet.
          <a
            href="#"
            @click.prevent="showInfo"
            class="text-primary text-decoration-underline"
            >Info lebih lanjut</a
          >
          <span class="ms-3">
            <span
              v-if="deviceApiService.hasAdminKey()"
              class="badge badge-light-success"
            >
              <i class="bi bi-cloud-check me-1"></i>Server Connected
            </span>
            <span v-else class="badge badge-light-warning">
              <i class="bi bi-cloud-slash me-1"></i>Local Mode
            </span>
          </span>
        </span>
      </h3>
      <div class="card-toolbar">
        <div class="btn-group" role="group">
          <button @click="openPairModal" class="btn btn-sm btn-primary">
            <i class="bi bi-qr-code me-2"></i>
            Pasangkan Kamera (QR)
          </button>
          <button
            @click="openAddDeviceModal"
            class="btn btn-sm btn-light-primary"
          >
            <span class="svg-icon svg-icon-2">
              <inline-svg src="/media/icons/duotune/arrows/arr075.svg" />
            </span>
            Daftar Baru
          </button>
          <button
            @click="openImportDeviceModal"
            class="btn btn-sm btn-light-success"
          >
            <i class="bi bi-plus-circle me-2"></i>
            Tambah yang Ada
          </button>
        </div>
      </div>
    </div>

    <!-- Info Banner for First Time Users -->
    <div
      v-if="devices.length === 0 && !loading"
      class="alert alert-info d-flex align-items-center mb-5 mx-9"
      role="alert"
    >
      <i class="bi bi-info-circle-fill me-3 fs-2"></i>
      <div class="flex-grow-1">
        <h6 class="alert-heading mb-2">
          Selamat Datang di Manajemen Perangkat IoT!
        </h6>
        <p class="mb-2">Untuk memulai, Anda dapat:</p>
        <ul class="mb-2">
          <li>
            <strong>Daftar Perangkat Baru</strong> - Jika Anda memiliki
            perangkat IoT yang belum terdaftar
          </li>
          <li>
            <strong>Tambah yang Sudah Ada</strong> - Jika perangkat sudah
            terdaftar sebelumnya
          </li>
        </ul>
        <small class="text-muted">
          <i class="bi bi-shield-check me-1"></i>
          Data perangkat akan disimpan secara aman di browser Anda
        </small>
      </div>
      <button @click="showInfo" class="btn btn-sm btn-light-primary ms-3">
        Pelajari Lebih Lanjut
      </button>
    </div>

    <!-- Search & Filter -->
    <div class="card-body pt-0">
      <div class="row mb-5">
        <div class="col-md-6 mb-2">
          <div class="input-group">
            <input
              type="search"
              class="form-control"
              placeholder="Cari berdasarkan ID, nama, atau lokasi..."
              v-model="searchQuery"
              @input="filterDevices"
              name="mw-device-search"
              autocomplete="off"
              autocorrect="off"
              autocapitalize="off"
              spellcheck="false"
              readonly
              @focus="$event.target.removeAttribute('readonly')"
            />
            <span class="input-group-text">
              <i class="bi bi-search"></i>
            </span>
          </div>
        </div>
        <div class="col-md-3 mb-2">
          <div class="d-flex align-items-center">
            <button
              @click="refreshDevices"
              class="btn btn-light-primary me-2"
              :disabled="loading"
            >
              <span
                v-if="loading"
                class="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              <i v-else class="bi bi-arrow-clockwise me-2"></i>
              Refresh
            </button>
            <button
              @click="exportToCSV"
              class="btn btn-light-success"
              :disabled="devices.length === 0"
            >
              <i class="bi bi-download me-2"></i>
              Export CSV
            </button>
          </div>
        </div>
        <div class="col-md-3 mb-2">
          <div class="d-flex align-items-center">
            <span class="text-muted me-3">
              Total: {{ deviceCount }} | Online: {{ onlineDevices }} | Offline:
              {{ offlineDevices }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Devices Table -->
    <div class="card-body pt-0">
      <div class="table-responsive">
        <table class="table align-middle table-row-dashed fs-6 gy-5">
          <thead>
            <tr
              class="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0"
            >
              <th class="min-w-125px">ID Perangkat</th>
              <th class="min-w-125px">Nama</th>
              <th class="min-w-125px">Lokasi</th>
              <th class="min-w-100px">Walet Hari Ini</th>
              <th class="min-w-125px">Stream Key</th>
              <th class="min-w-125px">Status</th>
              <th class="min-w-150px">Siaran / AI</th>
              <th class="min-w-150px">Pemilik</th>
              <th class="min-w-125px">Dibuat</th>
              <th class="text-end min-w-200px">Aksi</th>
            </tr>
          </thead>
          <tbody class="fw-semibold text-gray-600">
            <tr v-if="loading">
              <td colspan="10" class="text-center py-5">
                <div class="spinner-border" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </td>
            </tr>
            <tr v-else-if="filteredDevices.length === 0">
              <td colspan="10" class="text-center py-5">
                <div class="d-flex flex-column align-items-center">
                  <i
                    class="bi bi-hdd-network text-muted mb-3"
                    style="font-size: 3rem"
                  ></i>
                  <span class="text-gray-500 mb-3">{{
                    searchQuery
                      ? "Tidak ada perangkat yang ditemukan"
                      : "Belum ada perangkat yang terdaftar"
                  }}</span>
                  <div v-if="!searchQuery" class="d-flex gap-2">
                    <button
                      @click="openAddDeviceModal"
                      class="btn btn-sm btn-primary"
                    >
                      <i class="bi bi-plus-circle me-1"></i>
                      Daftar Perangkat Baru
                    </button>
                    <button
                      @click="openImportDeviceModal"
                      class="btn btn-sm btn-success"
                    >
                      <i class="bi bi-plus-circle me-1"></i>
                      Tambah yang Sudah Ada
                    </button>
                  </div>
                </div>
              </td>
            </tr>
            <tr
              v-else
              v-for="device in paginatedDevices"
              :key="device.id"
              :class="{
                'highlighted-row': String(device.id) === highlightedId,
              }"
            >
              <td>
                <div class="d-flex align-items-center">
                  <div
                    class="symbol symbol-circle symbol-50px overflow-hidden me-3"
                  >
                    <div class="symbol-label bg-light-primary">
                      <span class="svg-icon svg-icon-2x">
                        <inline-svg
                          src="/media/icons/duotune/electronics/elc004.svg"
                        />
                      </span>
                    </div>
                  </div>
                  <div class="d-flex flex-column">
                    <span class="text-gray-800 mb-1">{{ device.id }}</span>
                  </div>
                </div>
              </td>
              <td>
                <span class="text-dark fw-semibold">{{
                  device.name || "-"
                }}</span>
              </td>
              <td>
                <div class="d-flex flex-column">
                  <span class="text-dark fw-semibold">{{
                    device.location || "-"
                  }}</span>
                  <small
                    class="text-muted"
                    v-if="device.city || device.province"
                  >
                    {{
                      [device.city, device.province].filter(Boolean).join(", ")
                    }}
                  </small>
                </div>
              </td>
              <td>
                <div v-if="birdCounts[device.id]" class="d-flex flex-column">
                  <span
                    class="text-success fw-semibold"
                    title="Burung masuk hari ini"
                  >
                    <i class="bi bi-box-arrow-in-down me-1"></i
                    >{{ birdCounts[device.id].in }}
                  </span>
                  <span
                    class="text-danger fw-semibold"
                    title="Burung keluar hari ini"
                  >
                    <i class="bi bi-box-arrow-up me-1"></i
                    >{{ birdCounts[device.id].out }}
                  </span>
                </div>
                <span v-else class="text-muted">-</span>
              </td>
              <td>
                <div class="d-flex align-items-center">
                  <span class="text-dark fw-semibold me-2">{{
                    maskStreamKey(device.stream_key)
                  }}</span>
                  <button
                    class="btn btn-icon btn-sm btn-light-primary"
                    @click="copyStreamKey(device.stream_key)"
                    title="Copy Stream Key"
                  >
                    <i class="bi bi-clipboard"></i>
                  </button>
                </div>
              </td>
              <td>
                <span
                  v-if="device.stream_enabled === false"
                  class="badge badge-light-dark"
                  title="Siaran diputus — kamera tidak streaming"
                >
                  <i class="bi bi-power me-1"></i>Diputus
                </span>
                <span v-else :class="getStatusBadgeClass(device.status)">
                  {{ getStatusText(device.status) }}
                </span>
              </td>
              <td>
                <!-- Master connect/disconnect -->
                <div
                  class="form-check form-switch form-check-custom form-check-solid mb-2"
                >
                  <input
                    class="form-check-input h-20px w-30px"
                    type="checkbox"
                    :checked="device.stream_enabled !== false"
                    :disabled="streamBusy[device.id]"
                    @change="toggleStream(device)"
                    :id="`stream-${device.id}`"
                  />
                  <label
                    class="form-check-label fs-8 text-gray-700"
                    :for="`stream-${device.id}`"
                  >
                    <span
                      v-if="streamBusy[device.id]"
                      class="spinner-border spinner-border-sm"
                    ></span>
                    <span v-else>{{
                      device.stream_enabled === false ? "Siaran mati" : "Siaran"
                    }}</span>
                  </label>
                </div>
                <!-- AI counter overlay (only for Tuya cameras, and while connected) -->
                <div
                  v-if="isTuyaDevice(device)"
                  class="form-check form-switch form-check-custom form-check-solid"
                  :title="
                    device.stream_enabled === false
                      ? 'Aktifkan siaran dulu'
                      : 'Overlay AI penghitung walet. Matikan untuk siaran langsung tanpa overlay.'
                  "
                >
                  <input
                    class="form-check-input h-20px w-30px"
                    type="checkbox"
                    :checked="device.cv_enabled !== false"
                    :disabled="
                      cvBusy[device.id] || device.stream_enabled === false
                    "
                    @change="toggleCv(device)"
                    :id="`cv-${device.id}`"
                  />
                  <label
                    class="form-check-label fs-8 text-gray-700"
                    :for="`cv-${device.id}`"
                  >
                    <span
                      v-if="cvBusy[device.id]"
                      class="spinner-border spinner-border-sm"
                    ></span>
                    <span v-else>Overlay AI</span>
                  </label>
                </div>
                <span v-else class="text-muted fs-8">Non-Tuya</span>
              </td>
              <td>
                <div v-if="device.owner_uid" class="d-flex flex-column">
                  <span class="text-dark fw-semibold">{{
                    device.owner_name || device.owner_email || "—"
                  }}</span>
                  <small
                    class="text-muted"
                    v-if="device.owner_name && device.owner_email"
                    >{{ device.owner_email }}</small
                  >
                </div>
                <span v-else class="badge badge-light-warning"
                  >Belum ditetapkan</span
                >
              </td>
              <td>
                <div class="d-flex flex-column">
                  <span class="text-dark fw-semibold">{{
                    formatDate(device.created_at)
                  }}</span>
                  <span class="text-muted fs-7" v-if="device.lastSeen">
                    Last seen: {{ formatRelativeTime(device.lastSeen) }}
                  </span>
                </div>
              </td>
              <td class="text-end">
                <button
                  class="btn btn-icon btn-bg-light btn-active-color-success btn-sm me-1"
                  @click="watchDevice(device)"
                  title="Tonton Siaran Langsung"
                >
                  <i class="bi bi-play-circle-fill fs-4"></i>
                </button>
                <router-link
                  :to="`/iot/devices/${device.id}`"
                  class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                  title="Detail & Jadwal Streaming"
                >
                  <i class="bi bi-calendar-week fs-5"></i>
                </router-link>
                <button
                  class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                  @click="viewDevice(device)"
                  title="Lihat Detail"
                >
                  <span class="svg-icon svg-icon-3">
                    <inline-svg src="/media/icons/duotune/general/gen019.svg" />
                  </span>
                </button>
                <button
                  class="btn btn-icon btn-bg-light btn-active-color-info btn-sm me-1"
                  @click="openAssignOwner(device)"
                  title="Tetapkan Pemilik"
                >
                  <i class="bi bi-person-gear fs-5"></i>
                </button>
                <button
                  v-if="isTuyaDevice(device)"
                  class="btn btn-icon btn-bg-light btn-active-color-success btn-sm me-1"
                  @click="openHandoff(device)"
                  title="Serahkan ke Pemilik"
                >
                  <i class="bi bi-person-check fs-5"></i>
                </button>
                <button
                  class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                  @click="editDevice(device)"
                  title="Edit Perangkat"
                >
                  <span class="svg-icon svg-icon-3">
                    <inline-svg src="/media/icons/duotune/art/art005.svg" />
                  </span>
                </button>
                <button
                  class="btn btn-icon btn-bg-light btn-active-color-success btn-sm me-1"
                  @click="handleTestConnection(device)"
                  title="Test Koneksi"
                >
                  <span class="svg-icon svg-icon-3">
                    <inline-svg
                      src="/media/icons/duotune/communication/com012.svg"
                    />
                  </span>
                </button>
                <button
                  class="btn btn-icon btn-bg-light btn-active-color-warning btn-sm me-1"
                  @click="handleRegenerateStreamKey(device)"
                  title="Generate Ulang Stream Key"
                >
                  <span class="svg-icon svg-icon-3">
                    <inline-svg src="/media/icons/duotune/general/gen013.svg" />
                  </span>
                </button>
                <button
                  class="btn btn-icon btn-bg-light btn-active-color-info btn-sm me-1"
                  @click="confirmResetBirdCount(device)"
                  title="Reset Counter Hari Ini ke 0"
                >
                  <i class="bi bi-arrow-counterclockwise fs-4"></i>
                </button>
                <button
                  class="btn btn-icon btn-bg-light btn-active-color-warning btn-sm me-1"
                  @click="confirmClearAllData(device)"
                  title="Hapus SEMUA Data Hitung (mulai bersih)"
                >
                  <i class="bi bi-eraser fs-4"></i>
                </button>
                <button
                  class="btn btn-icon btn-bg-light btn-active-color-danger btn-sm"
                  @click="confirmDeleteDevice(device)"
                  title="Hapus Perangkat"
                >
                  <span class="svg-icon svg-icon-3">
                    <inline-svg src="/media/icons/duotune/general/gen027.svg" />
                  </span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div
        class="d-flex justify-content-between align-items-center flex-wrap mt-5"
        v-if="filteredDevices.length > 0"
      >
        <div class="d-flex flex-wrap py-2 mr-3">
          <span class="text-muted">
            Menampilkan {{ (currentPage - 1) * pageSize + 1 }} -
            {{ Math.min(currentPage * pageSize, filteredDevices.length) }}
            dari {{ filteredDevices.length }} perangkat
          </span>
        </div>
        <div class="d-flex flex-wrap py-2">
          <ul class="pagination">
            <li class="page-item" :class="{ disabled: currentPage === 1 }">
              <a
                class="page-link"
                href="#"
                @click.prevent="changePage(currentPage - 1)"
              >
                <span class="previous"></span>
              </a>
            </li>
            <li
              v-for="page in totalPages"
              :key="page"
              class="page-item"
              :class="{ active: page === currentPage }"
            >
              <a class="page-link" href="#" @click.prevent="changePage(page)">{{
                page
              }}</a>
            </li>
            <li
              class="page-item"
              :class="{ disabled: currentPage === totalPages }"
            >
              <a
                class="page-link"
                href="#"
                @click.prevent="changePage(currentPage + 1)"
              >
                <span class="next"></span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <!-- Add/Edit Device Modal -->
  <div class="modal fade" id="deviceModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered mw-650px">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ isEditing ? "Edit Perangkat IoT" : "Tambah Perangkat IoT Baru" }}
          </h5>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary ms-2"
            data-bs-dismiss="modal"
          >
            <span class="svg-icon svg-icon-2x">
              <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body">
          <!-- API Status Info for Edit Mode -->
          <div
            v-if="isEditing"
            class="alert alert-info d-flex align-items-center mb-4"
            role="alert"
          >
            <i class="bi bi-info-circle me-2"></i>
            <small>
              <span v-if="deviceApiService.hasAdminKey()">
                <strong>Mode Server:</strong> Perubahan akan disimpan ke server
                dan sinkron otomatis.
              </span>
              <span v-else>
                <strong>Mode Lokal:</strong> Perubahan hanya disimpan di
                browser. Untuk sinkron server, hubungi administrator.
              </span>
            </small>
          </div>

          <form @submit.prevent="submitDevice">
            <div class="mb-5">
              <label class="form-label">Nama Perangkat</label>
              <input
                type="text"
                class="form-control"
                v-model="deviceForm.name"
                placeholder="Masukkan nama perangkat (opsional)"
              />
              <div class="form-text">
                Nama untuk memudahkan identifikasi perangkat
                <span
                  v-if="isEditing && !deviceApiService.hasAdminKey()"
                  class="text-warning"
                >
                  (perubahan hanya tersimpan lokal)
                </span>
              </div>
            </div>
            <div class="mb-5">
              <label class="form-label">Lokasi</label>
              <input
                type="text"
                class="form-control"
                v-model="deviceForm.location"
                placeholder="Masukkan lokasi perangkat (opsional)"
              />
              <div class="form-text">
                Lokasi fisik perangkat
                <span
                  v-if="isEditing && !deviceApiService.hasAdminKey()"
                  class="text-warning"
                >
                  (perubahan hanya tersimpan lokal)
                </span>
              </div>
            </div>
            <div class="row mb-5">
              <div class="col-md-6">
                <label class="form-label">Kota</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="deviceForm.city"
                  placeholder="Kota (opsional)"
                />
              </div>
              <div class="col-md-6">
                <label class="form-label">Provinsi</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="deviceForm.province"
                  placeholder="Provinsi (opsional)"
                />
              </div>
            </div>
            <div class="mb-5">
              <label class="form-label">Password</label>
              <input
                type="password"
                class="form-control"
                v-model="deviceForm.password"
                :placeholder="
                  isEditing
                    ? 'Kosongkan jika tidak ingin mengubah password'
                    : 'Masukkan password untuk perangkat'
                "
                :required="!isEditing"
              />
              <div class="form-text">
                {{
                  isEditing
                    ? "Password digunakan untuk autentikasi perangkat"
                    : "Password akan digunakan untuk autentikasi perangkat"
                }}
              </div>
            </div>
            <div v-if="deviceForm.stream_key" class="mb-5">
              <label class="form-label">Stream Key</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  :value="deviceForm.stream_key"
                  readonly
                />
                <button
                  type="button"
                  class="btn btn-light"
                  @click="copyStreamKey(deviceForm.stream_key)"
                >
                  <i class="bi bi-clipboard"></i>
                </button>
              </div>
              <div class="form-text">
                Stream key akan digunakan untuk streaming data
              </div>
            </div>
            <div class="text-end">
              <button
                type="button"
                class="btn btn-light me-3"
                data-bs-dismiss="modal"
              >
                Batal
              </button>
              <button
                type="submit"
                class="btn btn-primary"
                :disabled="submitting"
              >
                <span
                  v-if="submitting"
                  class="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                {{ isEditing ? "Update Perangkat" : "Simpan Perangkat" }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- Device Import Modal -->
  <div
    class="modal fade"
    id="importDeviceModal"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered mw-650px">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Tambah Perangkat yang Sudah Ada</h5>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary ms-2"
            data-bs-dismiss="modal"
          >
            <span class="svg-icon svg-icon-2x">
              <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body">
          <div class="alert alert-info d-flex align-items-center" role="alert">
            <i class="bi bi-info-circle me-2"></i>
            <small>
              Gunakan fitur ini untuk menambahkan perangkat IoT yang sudah
              terdaftar sebelumnya ke dalam manajemen perangkat.
            </small>
          </div>

          <form @submit.prevent="importDevice">
            <div class="mb-5">
              <label class="form-label required">ID Perangkat</label>
              <input
                type="number"
                class="form-control"
                v-model="importForm.deviceId"
                placeholder="Masukkan ID perangkat"
                required
                min="1"
              />
              <div class="form-text">
                ID perangkat yang didapat saat registrasi perangkat
              </div>
            </div>

            <div class="mb-5">
              <label class="form-label required">Password</label>
              <input
                type="password"
                class="form-control"
                v-model="importForm.password"
                placeholder="Masukkan password perangkat"
                required
              />
              <div class="form-text">
                Password yang digunakan saat registrasi perangkat
              </div>
            </div>

            <div class="text-end">
              <button
                type="button"
                class="btn btn-light me-3"
                data-bs-dismiss="modal"
              >
                Batal
              </button>
              <button
                type="submit"
                class="btn btn-primary"
                :disabled="importing"
              >
                <span
                  v-if="importing"
                  class="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                <i v-else class="bi bi-plus-circle me-2"></i>
                Tambah Perangkat
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- Device Detail Modal -->
  <div class="modal fade" id="viewDeviceModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered mw-800px">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Detail Perangkat IoT</h5>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary ms-2"
            data-bs-dismiss="modal"
          >
            <span class="svg-icon svg-icon-2x">
              <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body" v-if="viewingDevice">
          <div class="row">
            <div class="col-md-6">
              <div class="card bg-light mb-5">
                <div class="card-body">
                  <div class="d-flex align-items-center mb-4">
                    <div class="symbol symbol-45px w-40px me-5">
                      <span class="symbol-label bg-primary">
                        <span class="svg-icon svg-icon-1 svg-icon-white">
                          <inline-svg
                            src="/media/icons/duotune/electronics/elc004.svg"
                          />
                        </span>
                      </span>
                    </div>
                    <div class="d-flex align-items-center flex-wrap w-100">
                      <div class="mb-1 pe-3 flex-grow-1">
                        <span class="fs-5 text-gray-800 fw-bold"
                          >ID Perangkat</span
                        >
                        <div class="text-gray-600 fw-semibold">
                          {{ viewingDevice.id }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="d-flex align-items-center mb-4">
                    <div class="symbol symbol-45px w-40px me-5">
                      <span class="symbol-label bg-success">
                        <span class="svg-icon svg-icon-1 svg-icon-white">
                          <inline-svg
                            src="/media/icons/duotune/general/gen015.svg"
                          />
                        </span>
                      </span>
                    </div>
                    <div class="d-flex align-items-center flex-wrap w-100">
                      <div class="mb-1 pe-3 flex-grow-1">
                        <span class="fs-5 text-gray-800 fw-bold">Nama</span>
                        <div class="text-gray-600 fw-semibold">
                          {{ viewingDevice.name || "Tidak ada nama" }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="d-flex align-items-center mb-4">
                    <div class="symbol symbol-45px w-40px me-5">
                      <span class="symbol-label bg-warning">
                        <span class="svg-icon svg-icon-1 svg-icon-white">
                          <inline-svg
                            src="/media/icons/duotune/maps/map004.svg"
                          />
                        </span>
                      </span>
                    </div>
                    <div class="d-flex align-items-center flex-wrap w-100">
                      <div class="mb-1 pe-3 flex-grow-1">
                        <span class="fs-5 text-gray-800 fw-bold">Lokasi</span>
                        <div class="text-gray-600 fw-semibold">
                          {{ viewingDevice.location || "Tidak ada lokasi" }}
                        </div>
                        <div
                          class="text-gray-500 fs-7"
                          v-if="viewingDevice.city || viewingDevice.province"
                        >
                          {{
                            [viewingDevice.city, viewingDevice.province]
                              .filter(Boolean)
                              .join(", ")
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="card bg-light mb-5">
                <div class="card-body">
                  <div class="d-flex align-items-center mb-4">
                    <div class="symbol symbol-45px w-40px me-5">
                      <span class="symbol-label bg-info">
                        <span class="svg-icon svg-icon-1 svg-icon-white">
                          <inline-svg
                            src="/media/icons/duotune/communication/com012.svg"
                          />
                        </span>
                      </span>
                    </div>
                    <div class="d-flex align-items-center flex-wrap w-100">
                      <div class="mb-1 pe-3 flex-grow-1">
                        <span class="fs-5 text-gray-800 fw-bold"
                          >Stream Key</span
                        >
                        <div class="d-flex align-items-center">
                          <span class="text-gray-600 fw-semibold me-2">
                            {{ maskStreamKey(viewingDevice.stream_key) }}
                          </span>
                          <button
                            class="btn btn-icon btn-sm btn-light-primary"
                            @click="copyStreamKey(viewingDevice.stream_key)"
                          >
                            <i class="bi bi-clipboard"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="d-flex align-items-center mb-4">
                    <div class="symbol symbol-45px w-40px me-5">
                      <span
                        class="symbol-label"
                        :class="
                          getStatusBadgeClass(viewingDevice.status).replace(
                            'badge',
                            'bg'
                          )
                        "
                      >
                        <span class="svg-icon svg-icon-1 svg-icon-white">
                          <inline-svg
                            src="/media/icons/duotune/communication/com012.svg"
                          />
                        </span>
                      </span>
                    </div>
                    <div class="d-flex align-items-center flex-wrap w-100">
                      <div class="mb-1 pe-3 flex-grow-1">
                        <span class="fs-5 text-gray-800 fw-bold">Status</span>
                        <div class="text-gray-600 fw-semibold">
                          {{ getStatusText(viewingDevice.status) }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="d-flex align-items-center mb-4">
                    <div class="symbol symbol-45px w-40px me-5">
                      <span class="symbol-label bg-dark">
                        <span class="svg-icon svg-icon-1 svg-icon-white">
                          <inline-svg
                            src="/media/icons/duotune/general/gen014.svg"
                          />
                        </span>
                      </span>
                    </div>
                    <div class="d-flex align-items-center flex-wrap w-100">
                      <div class="mb-1 pe-3 flex-grow-1">
                        <span class="fs-5 text-gray-800 fw-bold">Dibuat</span>
                        <div class="text-gray-600 fw-semibold">
                          {{ formatDate(viewingDevice.created_at) }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="d-flex align-items-center mb-4">
                    <div class="symbol symbol-45px w-40px me-5">
                      <span class="symbol-label bg-secondary">
                        <span class="svg-icon svg-icon-1 svg-icon-white">
                          <inline-svg
                            src="/media/icons/duotune/general/gen014.svg"
                          />
                        </span>
                      </span>
                    </div>
                    <div class="d-flex align-items-center flex-wrap w-100">
                      <div class="mb-1 pe-3 flex-grow-1">
                        <span class="fs-5 text-gray-800 fw-bold"
                          >Diperbarui</span
                        >
                        <div class="text-gray-600 fw-semibold">
                          {{ formatDate(viewingDevice.updated_at) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="text-end">
            <button
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
            >
              Tutup
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Delete Confirmation Modal -->
  <div class="modal fade" id="deleteModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Konfirmasi Hapus</h5>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary ms-2"
            data-bs-dismiss="modal"
          >
            <span class="svg-icon svg-icon-2x">
              <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body">
          <div class="text-center">
            <span class="svg-icon svg-icon-warning svg-icon-3x">
              <inline-svg src="/media/icons/duotune/general/gen044.svg" />
            </span>
            <div class="mt-5">
              <h3>Apakah Anda yakin?</h3>
              <p class="text-muted">
                Perangkat
                <strong>{{
                  deviceToDelete?.name || deviceToDelete?.id
                }}</strong>
                akan dihapus permanen dan tidak dapat dikembalikan.
              </p>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light" data-bs-dismiss="modal">
            Batal
          </button>
          <button
            type="button"
            class="btn btn-danger"
            @click="handleDeleteDevice"
            :disabled="deleting"
          >
            <span
              v-if="deleting"
              class="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            ></span>
            Ya, Hapus
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Pair Camera (QR) Modal -->
  <div class="modal fade" id="pairModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered mw-500px">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            <i class="bi bi-qr-code me-2"></i>Pasangkan Kamera Bardi A50
          </h5>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary ms-2"
            data-bs-dismiss="modal"
          >
            <span class="svg-icon svg-icon-2x">
              <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body">
          <!-- Step 1: WiFi form -->
          <div v-if="pairStep === 'form'">
            <p class="text-muted fs-7 mb-4">
              Masukkan WiFi rumah (khusus 2.4 GHz). Kamera akan menjadi milik
              akun Anda. Tanpa app Bardi/Tuya.
            </p>
            <div class="mb-3">
              <label class="form-label required"
                >Nama WiFi (SSID) — 2.4 GHz</label
              >
              <input
                type="text"
                class="form-control"
                v-model="pairSsid"
                placeholder="contoh: RBW-Lantai2"
              />
            </div>
            <div class="mb-3">
              <label class="form-label">Password WiFi</label>
              <input
                type="password"
                class="form-control"
                v-model="pairPwd"
                placeholder="password WiFi"
              />
            </div>
            <div class="mb-3">
              <label class="form-label">Nama Kamera (opsional)</label>
              <input
                type="text"
                class="form-control"
                v-model="pairName"
                placeholder="cth: RBW Lantai 2 - Timur"
              />
              <div class="form-text fs-8">
                Diisi otomatis ke perangkat setelah terpasang. Kosongkan untuk
                memakai nama bawaan.
              </div>
            </div>
            <div v-if="pairError" class="text-danger fs-8 mb-2">
              {{ pairError }}
            </div>
            <button
              class="btn btn-primary w-100"
              @click="generatePairing"
              :disabled="pairLoading || !pairSsid"
            >
              <span
                v-if="pairLoading"
                class="spinner-border spinner-border-sm me-2"
              ></span>
              Buat QR Pairing
            </button>
          </div>

          <!-- Step 2: QR shown, polling -->
          <div v-else-if="pairStep === 'qr'" class="text-center">
            <div class="d-inline-block p-3 bg-white rounded shadow-sm">
              <qrcode-vue :value="pairQrValue" :size="240" level="M" />
            </div>
            <div class="badge badge-light-primary mt-3">
              {{ pairExpiryText }}
            </div>
            <ol class="text-start fs-8 text-gray-700 mt-3">
              <li>
                Colok kamera, tunggu lampu berkedip cepat (reset bila perlu).
              </li>
              <li>Naikkan kecerahan layar ke maksimum.</li>
              <li>Arahkan <b>lensa kamera</b> ke QR ini (±15–20 cm).</li>
              <li>Tahan sampai kamera berbunyi "bip".</li>
            </ol>
            <div class="text-muted fs-8">
              <span class="spinner-border spinner-border-sm me-2"></span>
              Menunggu kamera terhubung…
            </div>
            <button
              class="btn btn-sm btn-light mt-3"
              @click="generatePairing"
              :disabled="pairLoading"
            >
              Buat Ulang QR
            </button>
          </div>

          <!-- Step 3: success -->
          <div v-else-if="pairStep === 'done'" class="text-center">
            <div style="font-size: 48px">✅</div>
            <h4 class="mb-1">
              {{
                pairedDevice?.re_paired
                  ? "Kamera terhubung kembali!"
                  : "Kamera berhasil dipasangkan!"
              }}
            </h4>
            <p class="text-muted fs-7">
              {{ pairedDevice?.name || "Kamera #" + pairedDevice?.id }}
            </p>
            <div class="alert alert-success text-start fs-8 mt-3">
              <i class="bi bi-broadcast me-1"></i>
              <span v-if="pairedDevice?.re_paired">
                Siaran berlanjut otomatis — tidak perlu tindakan tambahan.
              </span>
              <span v-else>
                Siaran akan aktif otomatis dalam ±1–2 menit (server memprovision
                worker sendiri). Kamera ini menjadi milik akun Anda.
              </span>
            </div>
            <button
              class="btn btn-primary w-100"
              data-bs-dismiss="modal"
              @click="finishPairing"
            >
              Selesai
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Assign Owner Modal -->
  <div
    class="modal fade"
    id="assignOwnerModal"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered mw-500px">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            <i class="bi bi-person-gear me-2"></i>Tetapkan Pemilik Perangkat
          </h5>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary ms-2"
            data-bs-dismiss="modal"
          >
            <span class="svg-icon svg-icon-2x">
              <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body" v-if="assigningDevice">
          <p class="text-muted fs-7 mb-4">
            Perangkat
            <strong>{{
              assigningDevice.name || "#" + assigningDevice.id
            }}</strong>
            hanya akan terlihat oleh pemiliknya (dan admin). Masukkan email akun
            pengguna untuk menetapkannya.
          </p>
          <div class="mb-3">
            <label class="form-label">Email Pemilik</label>
            <input
              type="email"
              class="form-control"
              v-model="assignEmail"
              placeholder="cth: pemilik@email.com"
              autocomplete="off"
            />
            <div class="form-text" v-if="assigningDevice.owner_email">
              Saat ini: {{ assigningDevice.owner_email }}
            </div>
          </div>
          <div class="text-end">
            <button
              type="button"
              class="btn btn-light-danger me-2"
              v-if="assigningDevice.owner_uid"
              @click="submitAssignOwner(true)"
              :disabled="assigning"
            >
              Hapus Pemilik
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="submitAssignOwner(false)"
              :disabled="assigning || !assignEmail"
            >
              <span
                v-if="assigning"
                class="spinner-border spinner-border-sm me-2"
              ></span>
              Simpan
            </button>
          </div>

          <!-- Share access with specific users (besides owner + admins) -->
          <div class="separator my-5"></div>
          <h6 class="mb-1">
            <i class="bi bi-people me-2"></i>Bagikan Akses ke Pengguna Lain
          </h6>
          <p class="text-muted fs-8 mb-3">
            Pengguna ini bisa melihat &amp; menonton kamera (tanpa mengubah
            pengaturan). Berlaku di web &amp; aplikasi mobile.
          </p>
          <div
            v-if="assigningDevice.shares && assigningDevice.shares.length"
            class="mb-3"
          >
            <div
              v-for="s in assigningDevice.shares"
              :key="s.uid"
              class="d-flex align-items-center justify-content-between bg-light rounded px-3 py-2 mb-2"
            >
              <span class="fs-7">{{ s.name || s.email || s.uid }}</span>
              <button
                class="btn btn-sm btn-icon btn-active-color-danger"
                title="Cabut akses"
                @click="removeShare(s.uid)"
                :disabled="sharingBusy"
              >
                <i class="bi bi-x-lg"></i>
              </button>
            </div>
          </div>
          <div v-else class="text-muted fs-8 mb-3">
            Belum dibagikan ke siapa pun.
          </div>
          <div class="input-group">
            <input
              type="email"
              class="form-control"
              v-model="shareEmail"
              placeholder="email pengguna untuk dibagikan"
              autocomplete="off"
            />
            <button
              class="btn btn-light-primary"
              @click="addShare"
              :disabled="sharingBusy || !shareEmail"
            >
              <span
                v-if="sharingBusy"
                class="spinner-border spinner-border-sm me-2"
              ></span>
              Bagikan
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Handoff (Serahkan ke Pemilik) Modal -->
  <div class="modal fade" id="handoffModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered mw-500px">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            <i class="bi bi-person-check me-2"></i>Serahkan Kamera ke Pemilik
          </h5>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary ms-2"
            data-bs-dismiss="modal"
          >
            <span class="svg-icon svg-icon-2x">
              <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body" v-if="handoffDevice">
          <p class="text-muted fs-7 mb-4">
            Serahkan kamera
            <strong>{{ handoffDevice.name || "#" + handoffDevice.id }}</strong>
            ke pengguna akhir. Kepemilikan berpindah ke email di bawah, lalu
            seluruh riwayat hitung QC dihapus agar pemilik mulai dari data
            bersih.
          </p>
          <div class="mb-3">
            <label class="form-label required">Email pemilik baru</label>
            <input
              type="email"
              class="form-control"
              v-model="handoffEmail"
              placeholder="cth: pemilik@email.com"
              autocomplete="off"
            />
            <div class="form-text" v-if="handoffDevice.owner_email">
              Pemilik saat ini: {{ handoffDevice.owner_email }}
            </div>
          </div>
          <div class="mb-3">
            <label class="form-label">Nama perangkat</label>
            <input
              type="text"
              class="form-control"
              v-model="handoffName"
              placeholder="Nama perangkat (opsional)"
            />
          </div>
          <div class="mb-3">
            <label class="form-label">Lokasi</label>
            <input
              type="text"
              class="form-control"
              v-model="handoffLocation"
              placeholder="Lokasi perangkat (opsional)"
            />
          </div>
          <div
            class="alert alert-warning d-flex align-items-start"
            role="alert"
          >
            <i class="bi bi-exclamation-triangle-fill me-2 mt-1"></i>
            <small>
              <strong>Perhatian:</strong> Seluruh riwayat hitung QC untuk kamera
              ini akan <strong>direset ke 0</strong> dan tidak dapat
              dikembalikan.
            </small>
          </div>
          <div class="text-end">
            <button
              type="button"
              class="btn btn-light me-3"
              data-bs-dismiss="modal"
              :disabled="handoffBusy"
            >
              Batal
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="submitHandoff"
              :disabled="handoffBusy || !handoffEmail"
            >
              <span
                v-if="handoffBusy"
                class="spinner-border spinner-border-sm me-2"
              ></span>
              Serahkan
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Live Stream Modal -->
  <div
    class="modal fade"
    id="watchDeviceModal"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered mw-900px">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            <i class="bi bi-camera-video me-2"></i>Siaran Langsung —
            {{
              watchingDevice
                ? watchingDevice.name || "Perangkat #" + watchingDevice.id
                : ""
            }}
          </h5>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary ms-2"
            data-bs-dismiss="modal"
          >
            <span class="svg-icon svg-icon-2x">
              <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body" v-if="watchingDevice">
          <LiveStreamPlayer
            :stream-key="watchingDevice.stream_key"
            :device-id="watchingDevice.id"
            :mode="watchPlayerMode"
            :active="watchActive"
            :scheduled="watchScheduled"
            :schedule-active="watchWithin"
            :schedule-label="watchScheduleLabel"
          />
          <p class="text-muted fs-8 mt-3 mb-0">
            <span v-if="watchPlayerMode === 'off'">
              <i class="bi bi-power me-1"></i>Siaran kamera ini sedang diputus.
              Aktifkan kembali dari kolom "Siaran / AI" untuk menonton.
            </span>
            <span v-else-if="watchPlayerMode === 'direct'">
              <i class="bi bi-broadcast me-1"></i>
              <template v-if="watchOutsideWindow">
                Di luar jam aktif — siaran langsung dari kamera (tanpa overlay
                AI) untuk hemat kuota. Overlay penghitung aktif otomatis saat
                jam terjadwal.
              </template>
              <template v-else>
                Siaran langsung dari kamera (tanpa overlay AI).
              </template>
            </span>
            <span v-else>
              Overlay penghitung burung walet sudah menyatu di dalam siaran.
            </span>
            <span v-if="watchingDevice.location">
              Lokasi: {{ watchingDevice.location }}</span
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted, reactive } from "vue";
import { useRoute } from "vue-router";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { Modal } from "bootstrap";
import { useDevices } from "@/composables/useDevices";
import { DeviceHelpers } from "@/util/deviceHelpers";
import { NotificationService } from "@/util/notification";
import { deviceApiService, DeviceApiError } from "@/services/DeviceApiService";
import { DeviceStorageService } from "@/services/DeviceStorageService";
import type { DeviceWithMetadata } from "@/composables/useDevices";
import LiveStreamPlayer from "@/components/dashboard/iot/LiveStreamPlayer.vue";
import QrcodeVue from "qrcode.vue";

export default defineComponent({
  name: "iot-device-management",
  components: { LiveStreamPlayer, QrcodeVue },

  setup() {
    // Use devices composable
    const {
      devices,
      loading,
      deviceForm,
      isEditing,
      editingDeviceId,
      submitting,
      deviceCount,
      onlineDevices,
      offlineDevices,
      addDevice,
      updateDevice,
      deleteDevice,
      regenerateStreamKey,
      testDeviceConnection,
      resetForm,
      setFormData,
      maskStreamKey,
      copyToClipboard,
      formatDate,
      formatRelativeTime,
      exportToCSV,
      promptForPassword,
      initialize,
      addDeviceToList,
      refreshDevicesFromAPI,
    } = useDevices();

    // Import device form
    const importForm = reactive({
      deviceId: null as number | null,
      password: "",
    });
    const importing = ref(false);

    // Local state for UI
    const searchQuery = ref("");
    const currentPage = ref(1);
    const pageSize = ref(10);
    const viewingDevice = ref<DeviceWithMetadata | null>(null);
    const deviceToDelete = ref<DeviceWithMetadata | null>(null);
    const deleting = ref(false);
    const sortField = ref<keyof DeviceWithMetadata>("id");
    const sortOrder = ref<"asc" | "desc">("desc");

    // Row highlight (from Statistik IoT deep-link ?highlight=ID)
    const route = useRoute();
    const highlightedId = ref<string | null>(null);

    // Live stream modal state
    const watchingDevice = ref<DeviceWithMetadata | null>(null);
    const watchActive = ref(false);

    // Assign-owner modal state
    const assigningDevice = ref<DeviceWithMetadata | null>(null);
    const assignEmail = ref("");
    const assigning = ref(false);
    const shareEmail = ref("");
    const sharingBusy = ref(false);

    // Handoff ("Serahkan ke Pemilik") modal state — transfer ownership + reset
    // QC counting history in one flow.
    const handoffDevice = ref<DeviceWithMetadata | null>(null);
    const handoffEmail = ref("");
    const handoffName = ref("");
    const handoffLocation = ref("");
    const handoffBusy = ref(false);

    // Per-device busy flags while toggling streaming / AI overlay.
    const streamBusy = ref<Record<number, boolean>>({});
    const cvBusy = ref<Record<number, boolean>>({});

    // Pair-camera (QR) modal state
    const pairStep = ref<"form" | "qr" | "done">("form");
    const pairSsid = ref("");
    const pairPwd = ref("");
    const pairName = ref("");
    const pairLoading = ref(false);
    const pairError = ref("");
    const pairQrValue = ref("");
    const pairExpiryText = ref("");
    const pairedDevice = ref<any | null>(null);
    let pairPollTimer: any = null;
    let pairExpiryTimer: any = null;
    let pairToken: string | null = null;

    // Today's bird counts per device (device_id -> { in, out }), from bird-stats
    const birdCounts = ref<Record<number, { in: number; out: number }>>({});

    // Modal instances
    let deviceModal: Modal | null = null;
    let viewModal: Modal | null = null;
    let deleteModal: Modal | null = null;
    let importModal: Modal | null = null;
    let watchModal: Modal | null = null;
    let assignModal: Modal | null = null;
    let handoffModal: Modal | null = null;
    let pairModal: Modal | null = null;

    // Computed properties for filtering and pagination
    const filteredDevices = computed(() => {
      let result = devices.value;

      // Apply search filter
      if (searchQuery.value) {
        const query = searchQuery.value.toLowerCase();
        result = result.filter(
          (device) =>
            device.id.toString().includes(query) ||
            (device.name && device.name.toLowerCase().includes(query)) ||
            (device.location && device.location.toLowerCase().includes(query))
        );
      }

      // Apply sorting
      result = [...result].sort((a, b) => {
        const aValue = a[sortField.value];
        const bValue = b[sortField.value];

        if (aValue == null && bValue == null) return 0;
        if (aValue == null) return sortOrder.value === "asc" ? 1 : -1;
        if (bValue == null) return sortOrder.value === "asc" ? -1 : 1;

        if (typeof aValue === "string" && typeof bValue === "string") {
          return sortOrder.value === "asc"
            ? aValue.localeCompare(bValue)
            : bValue.localeCompare(aValue);
        }

        if (typeof aValue === "number" && typeof bValue === "number") {
          return sortOrder.value === "asc" ? aValue - bValue : bValue - aValue;
        }

        return 0;
      });

      return result;
    });

    const paginatedDevices = computed(() => {
      const startIdx = (currentPage.value - 1) * pageSize.value;
      const endIdx = startIdx + pageSize.value;
      return filteredDevices.value.slice(startIdx, endIdx);
    });

    const totalPages = computed(() => {
      return Math.ceil(filteredDevices.value.length / pageSize.value);
    });

    // Methods for UI interactions
    const refreshDevices = async () => {
      // Try to refresh from API first
      const refreshedFromAPI = await refreshDevicesFromAPI();

      if (!refreshedFromAPI) {
        // Fallback to local storage refresh
        const stats = DeviceStorageService.getStorageStats();

        const result = await NotificationService.confirm(
          `Saat ini terdapat ${stats.deviceCount} perangkat dalam penyimpanan lokal.\n\nApakah Anda ingin memuat ulang data dari penyimpanan?`,
          "Refresh Data Perangkat",
          "Ya, Muat Ulang",
          "Batal"
        );

        if (result.isConfirmed) {
          loading.value = true;
          try {
            // Reload devices from storage
            devices.value = DeviceStorageService.loadDevices();
            currentPage.value = 1;

            await NotificationService.success(
              `Data perangkat berhasil dimuat ulang dari penyimpanan lokal. Total: ${devices.value.length} perangkat`
            );
          } finally {
            loading.value = false;
          }
        }
      } else {
        // Reset pagination when data refreshed from API
        currentPage.value = 1;
      }

      // Refresh today's bird counts alongside the device list.
      await loadBirdCounts();
    };

    const filterDevices = () => {
      currentPage.value = 1;
    };

    const changePage = (page: number) => {
      if (page >= 1 && page <= totalPages.value) {
        currentPage.value = page;
      }
    };

    const setSorting = (field: keyof DeviceWithMetadata) => {
      if (sortField.value === field) {
        sortOrder.value = sortOrder.value === "asc" ? "desc" : "asc";
      } else {
        sortField.value = field;
        sortOrder.value = "asc";
      }
    };

    const copyStreamKey = async (streamKey: string) => {
      await copyToClipboard(streamKey, "Stream key berhasil disalin");
    };

    const getStatusBadgeClass = DeviceHelpers.getStatusBadgeClass;
    const getStatusText = DeviceHelpers.getStatusText;

    // Modal functions
    const openAddDeviceModal = () => {
      isEditing.value = false;
      editingDeviceId.value = null;
      resetForm();

      if (!deviceModal) {
        deviceModal = new Modal(
          document.getElementById("deviceModal") as HTMLElement
        );
      }
      deviceModal.show();
    };

    const openImportDeviceModal = () => {
      // Reset import form
      importForm.deviceId = null;
      importForm.password = "";

      if (!importModal) {
        importModal = new Modal(
          document.getElementById("importDeviceModal") as HTMLElement
        );
      }
      importModal.show();
    };

    const editDevice = (device: DeviceWithMetadata) => {
      isEditing.value = true;
      editingDeviceId.value = device.id;
      setFormData(device);

      if (!deviceModal) {
        deviceModal = new Modal(
          document.getElementById("deviceModal") as HTMLElement
        );
      }
      deviceModal.show();
    };

    const viewDevice = (device: DeviceWithMetadata) => {
      viewingDevice.value = device;

      if (!viewModal) {
        viewModal = new Modal(
          document.getElementById("viewDeviceModal") as HTMLElement
        );
      }
      viewModal.show();
    };

    const watchDevice = (device: DeviceWithMetadata) => {
      watchingDevice.value = device;

      // Load the device's active windows so the player can fall back to the raw
      // Tuya feed when we're outside the streaming schedule (CV pipeline paused).
      watchWindows.value = null;
      deviceApiService
        .getDeviceConfig(device.id)
        .then((cfg) => {
          watchWindows.value = parseWindows(cfg || {});
        })
        .catch(() => {
          watchWindows.value = []; // treat as 24/7 on error
        });

      const modalEl = document.getElementById(
        "watchDeviceModal"
      ) as HTMLElement;
      if (!watchModal) {
        watchModal = new Modal(modalEl);
      }

      // Activate the player only once the modal is shown, and tear it down on
      // close so the stream stops fetching in the background.
      modalEl.addEventListener(
        "shown.bs.modal",
        () => {
          watchActive.value = true;
          // re-evaluate cv/direct each minute so a mid-session boundary flips it
          if (watchTickTimer) clearInterval(watchTickTimer);
          watchTickTimer = setInterval(() => {
            nowTick.value++;
          }, 60000);
        },
        { once: true }
      );
      modalEl.addEventListener(
        "hidden.bs.modal",
        () => {
          watchActive.value = false;
          watchingDevice.value = null;
          watchWindows.value = null;
          if (watchTickTimer) {
            clearInterval(watchTickTimer);
            watchTickTimer = null;
          }
        },
        { once: true }
      );

      watchModal.show();
    };

    const openAssignOwner = (device: DeviceWithMetadata) => {
      assigningDevice.value = device;
      assignEmail.value = device.owner_email || "";
      shareEmail.value = "";
      if (!assignModal) {
        assignModal = new Modal(
          document.getElementById("assignOwnerModal") as HTMLElement
        );
      }
      assignModal.show();
    };

    const submitAssignOwner = async (unassign: boolean) => {
      if (!assigningDevice.value) return;
      assigning.value = true;
      try {
        await deviceApiService.assignOwner({
          device_id: assigningDevice.value.id,
          ...(unassign ? {} : { owner_email: assignEmail.value.trim() }),
        });
        await NotificationService.success(
          unassign
            ? "Pemilik berhasil dihapus."
            : "Pemilik berhasil ditetapkan."
        );
        assignModal?.hide();
        await refreshDevices();
      } catch (e) {
        await NotificationService.error(
          e instanceof DeviceApiError ? e.message : "Gagal menetapkan pemilik.",
          "Gagal"
        );
      } finally {
        assigning.value = false;
      }
    };

    // --- One-click handoff to end user -------------------------------------
    // Opens the "Serahkan ke Pemilik" modal, prefilling the current name/location.
    const openHandoff = (device: DeviceWithMetadata) => {
      handoffDevice.value = device;
      handoffEmail.value = "";
      handoffName.value = device.name || "";
      handoffLocation.value = device.location || "";
      if (!handoffModal) {
        handoffModal = new Modal(
          document.getElementById("handoffModal") as HTMLElement
        );
      }
      handoffModal.show();
    };

    // Runs the handoff steps sequentially: (a) transfer ownership, (b) wipe ALL
    // QC counting history, (c) optionally rename/relocate. Aborts on the first
    // failure and reports which step failed. If ownership already transferred
    // before a later step failed, the user is told so they don't retry blindly.
    const submitHandoff = async () => {
      if (!handoffDevice.value) return;

      const email = handoffEmail.value.trim();
      // Block empty / obviously-invalid email before touching the server.
      const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
      if (!emailValid) {
        await NotificationService.warning(
          "Masukkan email pemilik baru yang valid."
        );
        return;
      }

      const deviceId = handoffDevice.value.id;
      handoffBusy.value = true;
      let ownershipTransferred = false;
      let step = "menyerahkan kepemilikan";
      try {
        // (a) Transfer ownership to the new owner.
        await deviceApiService.assignOwner({
          device_id: deviceId,
          owner_email: email,
        });
        ownershipTransferred = true;

        // (b) Wipe ALL counting history so the owner starts from a clean slate.
        step = "mereset data QC";
        await deviceApiService.resetBirdCount(deviceId, true);

        // (c) Optionally apply the (possibly edited) name / location.
        const name = handoffName.value.trim();
        const location = handoffLocation.value.trim();
        const patch: { id: number; name?: string; location?: string } = {
          id: deviceId,
        };
        if (name) patch.name = name;
        if (location) patch.location = location;
        if (patch.name !== undefined || patch.location !== undefined) {
          step = "memperbarui nama/lokasi perangkat";
          await deviceApiService.updateDevice(patch);
        }

        await NotificationService.success(
          `Kamera diserahkan ke ${email}. Data QC direset.`
        );
        handoffModal?.hide();
        await refreshDevices();
      } catch (e) {
        const detail = e instanceof DeviceApiError ? e.message : "";
        let msg = `Gagal saat ${step}.`;
        if (detail) msg += ` ${detail}`;
        if (ownershipTransferred) {
          // Ownership already moved — warn against re-running the whole flow.
          msg += ` Namun kepemilikan SUDAH berpindah ke ${email} — jangan ulangi penyerahan dari awal; selesaikan langkah "${step}" secara manual.`;
        }
        await NotificationService.error(msg, "Serah Terima Gagal");
      } finally {
        handoffBusy.value = false;
      }
    };

    const addShare = async () => {
      if (!assigningDevice.value || !shareEmail.value.trim()) return;
      sharingBusy.value = true;
      try {
        const res = await deviceApiService.shareDevice(
          assigningDevice.value.id,
          shareEmail.value.trim()
        );
        const list = assigningDevice.value.shares || [];
        if (!list.some((s) => s.uid === res.share.uid)) {
          list.push(res.share);
        }
        assigningDevice.value.shares = list;
        shareEmail.value = "";
        await NotificationService.success("Akses berhasil dibagikan.");
        await refreshDevices();
      } catch (e) {
        await NotificationService.error(
          e instanceof DeviceApiError ? e.message : "Gagal membagikan akses.",
          "Gagal"
        );
      } finally {
        sharingBusy.value = false;
      }
    };

    const removeShare = async (uid: string) => {
      if (!assigningDevice.value) return;
      sharingBusy.value = true;
      try {
        await deviceApiService.unshareDevice(assigningDevice.value.id, uid);
        assigningDevice.value.shares = (
          assigningDevice.value.shares || []
        ).filter((s) => s.uid !== uid);
        await refreshDevices();
      } catch (e) {
        await NotificationService.error("Gagal mencabut akses.", "Gagal");
      } finally {
        sharingBusy.value = false;
      }
    };

    // --- Pair camera via QR ------------------------------------------------
    const stopPairTimers = () => {
      if (pairPollTimer) {
        clearInterval(pairPollTimer);
        pairPollTimer = null;
      }
      if (pairExpiryTimer) {
        clearInterval(pairExpiryTimer);
        pairExpiryTimer = null;
      }
    };

    const openPairModal = () => {
      stopPairTimers();
      pairStep.value = "form";
      pairSsid.value = "";
      pairPwd.value = "";
      pairName.value = "";
      pairError.value = "";
      pairedDevice.value = null;
      const el = document.getElementById("pairModal") as HTMLElement;
      if (!pairModal) {
        pairModal = new Modal(el);
        el.addEventListener("hidden.bs.modal", stopPairTimers);
      }
      pairModal.show();
    };

    const pollPairing = async () => {
      if (!pairToken) return;
      try {
        const found = await deviceApiService.discoverDevices(pairToken);
        const fresh = found.find((d) => d.is_new);
        if (fresh) {
          stopPairTimers();
          pairedDevice.value = fresh;
          pairStep.value = "done";
          // Apply the chosen name (web has no auto-rename like the mobile app).
          const name = pairName.value.trim();
          if (name) {
            try {
              await deviceApiService.updateDevice({ id: fresh.id, name });
              (pairedDevice.value as any).name = name;
            } catch (_) {
              /* non-fatal — admin can rename via Edit */
            }
          }
        }
      } catch (_) {
        /* keep polling */
      }
    };

    const generatePairing = async () => {
      if (!pairSsid.value.trim()) {
        pairError.value = "Nama WiFi (SSID) wajib diisi";
        return;
      }
      pairLoading.value = true;
      pairError.value = "";
      try {
        const t = await deviceApiService.getPairingToken("EZ");
        if (!t.token) throw new Error("empty token");
        pairToken = t.token;
        const authToken = (t.region || "") + t.token + (t.secret || "");
        // Tuya camera QR: keys ordered p,s,t; t = region+token+secret.
        pairQrValue.value = JSON.stringify({
          p: pairPwd.value,
          s: pairSsid.value.trim(),
          t: authToken,
        });
        pairStep.value = "qr";

        // Expiry countdown.
        stopPairTimers();
        let left = t.expire_time || 300;
        const tick = () => {
          if (left <= 0) {
            pairExpiryText.value = "Token kedaluwarsa — buat ulang QR";
            if (pairExpiryTimer) clearInterval(pairExpiryTimer);
            return;
          }
          const m = Math.floor(left / 60);
          const s = String(left % 60).padStart(2, "0");
          pairExpiryText.value = `Berlaku ${m}:${s}`;
          left--;
        };
        tick();
        pairExpiryTimer = setInterval(tick, 1000);
        pairPollTimer = setInterval(pollPairing, 5000);
      } catch (e: any) {
        // Surface the server's message (e.g. Tuya quota exhausted) instead of a
        // generic retry prompt, so the real cause is obvious.
        const serverMsg = e?.response?.data?.error;
        pairError.value =
          serverMsg || "Gagal membuat QR. Pastikan Anda admin & coba lagi.";
      } finally {
        pairLoading.value = false;
      }
    };

    const finishPairing = async () => {
      stopPairTimers();
      await refreshDevices();
    };

    /**
     * Load today's bird counts per device from the bird-stats endpoint.
     * Degrades gracefully (leaves counts empty) when no admin key / on error.
     */
    const loadBirdCounts = async () => {
      if (!deviceApiService.hasAdminKey()) return;
      try {
        const stats = await deviceApiService.getBirdStats("day");
        const map: Record<number, { in: number; out: number }> = {};
        for (const d of stats.data) {
          map[d.device_id] = {
            in: d.total_in || 0,
            out: d.total_out || 0,
          };
        }
        birdCounts.value = map;
      } catch (error) {
        console.warn("Failed to load bird counts:", error);
      }
    };

    const submitDevice = async () => {
      if (isEditing.value && editingDeviceId.value) {
        deviceModal?.hide();

        // Admin key is enough — no device password needed
        const success = await updateDevice(editingDeviceId.value, "", {
          name: deviceForm.name,
          location: deviceForm.location,
          city: deviceForm.city,
          province: deviceForm.province,
        });

        if (success) {
          resetForm();
        } else {
          deviceModal?.show();
        }
      } else {
        const success = await addDevice({
          name: deviceForm.name || undefined,
          location: deviceForm.location || undefined,
          city: deviceForm.city || undefined,
          province: deviceForm.province || undefined,
          password: deviceForm.password,
        });

        if (success) {
          deviceModal?.hide();
          resetForm();
        }
      }
    };

    const handleRegenerateStreamKey = async (device: DeviceWithMetadata) => {
      // Ensure any open modals are closed first
      deviceModal?.hide();
      viewModal?.hide();
      deleteModal?.hide();

      // Wait for modals to close
      await new Promise((resolve) => setTimeout(resolve, 300));

      const password = await promptForPassword(
        "Generate Ulang Stream Key",
        "Masukkan password perangkat untuk generate ulang stream key"
      );

      if (password) {
        await regenerateStreamKey(device.id, password);
      }
    };

    const confirmResetBirdCount = async (device: DeviceWithMetadata) => {
      const result = await NotificationService.confirm(
        `Counter burung walet pada perangkat "${DeviceHelpers.getDeviceDisplayName(
          device
        )}" akan direset ke 0.\n\nData hari ini akan dihapus dan tidak dapat dikembalikan.`,
        "Reset Counter ke 0",
        "Ya, Reset",
        "Batal"
      );
      if (!result.isConfirmed) return;

      try {
        await deviceApiService.resetBirdCount(device.id);
        await NotificationService.success("Counter berhasil direset ke 0.");
        await refreshDevices();
      } catch (e) {
        await NotificationService.error(
          "Gagal mereset counter. Pastikan admin key sudah diset."
        );
      }
    };

    const confirmClearAllData = async (device: DeviceWithMetadata) => {
      const result = await NotificationService.confirmDelete(
        `SEMUA data hitung (in/out) perangkat "${DeviceHelpers.getDeviceDisplayName(
          device
        )}" akan dihapus permanen — untuk memulai dengan data bersih. Tindakan ini tidak dapat dibatalkan.`,
        "Hapus Semua Data Hitung?"
      );
      if (!result.isConfirmed) return;

      try {
        const res = await deviceApiService.resetBirdCount(device.id, true);
        await NotificationService.success(
          res.message || "Semua data hitung berhasil dihapus."
        );
        await refreshDevices();
      } catch (e) {
        await NotificationService.error("Gagal menghapus data. Coba lagi.");
      }
    };

    const confirmDeleteDevice = (device: DeviceWithMetadata) => {
      deviceToDelete.value = device;

      if (!deleteModal) {
        deleteModal = new Modal(
          document.getElementById("deleteModal") as HTMLElement
        );
      }
      deleteModal.show();
    };

    const handleDeleteDevice = async () => {
      if (!deviceToDelete.value) return;

      // Close delete modal first
      deleteModal?.hide();

      // Wait for modal to close
      await new Promise((resolve) => setTimeout(resolve, 300));

      // Show confirmation dialog first
      const result = await NotificationService.confirmDelete(
        `Perangkat "${DeviceHelpers.getDeviceDisplayName(
          deviceToDelete.value
        )}" akan dihapus permanen dan tidak dapat dikembalikan.`,
        "Apakah Anda yakin?"
      );

      if (!result.isConfirmed) {
        deviceToDelete.value = null;
        return;
      }

      deleting.value = true;

      try {
        // Admin key is enough — no device password needed
        const success = await deleteDevice(deviceToDelete.value.id, "");

        if (success) {
          deviceToDelete.value = null;
          // Re-sync the list from the server so the deleted device can never
          // linger in the view (or be resurrected from a stale local cache).
          await refreshDevicesFromAPI(true);
        }
      } finally {
        deleting.value = false;
      }
    };

    const handleTestConnection = async (device: DeviceWithMetadata) => {
      // Ensure any open modals are closed first
      deviceModal?.hide();
      viewModal?.hide();
      deleteModal?.hide();

      // Wait for modals to close
      await new Promise((resolve) => setTimeout(resolve, 300));

      const password = await promptForPassword(
        "Test Koneksi",
        "Masukkan password perangkat untuk test koneksi"
      );

      if (password) {
        await testDeviceConnection(device.id, password);
      }
    };

    const importDevice = async () => {
      if (!importForm.deviceId || !importForm.password) {
        await NotificationService.warning("Semua field harus diisi");
        return;
      }

      importing.value = true;

      try {
        // Get device data from API to verify it exists and credentials are correct
        const deviceData = await deviceApiService.getDeviceData({
          id: importForm.deviceId,
          password: importForm.password,
        });

        // Check if device already exists in local storage
        const existingDevice = devices.value.find(
          (d) => d.id === deviceData.id
        );
        if (existingDevice) {
          await NotificationService.warning(
            `Perangkat #${deviceData.id} sudah ada dalam daftar manajemen perangkat`
          );
          return;
        }

        // Create device object for local storage
        const device = {
          id: deviceData.id,
          name: deviceData.name,
          location: deviceData.location,
          stream_key: deviceData.stream_key,
          created_at: new Date().toISOString(), // We don't have the real creation date
          updated_at: new Date().toISOString(),
        };

        // Add to local device list
        addDeviceToList(device);

        // Show success message
        await NotificationService.success(
          `Perangkat #${device.id} berhasil ditambahkan ke manajemen perangkat`
        );

        // Reset form
        importForm.deviceId = null;
        importForm.password = "";

        // Close modal
        importModal?.hide();
      } catch (error) {
        console.error("Error importing device:", error);

        if (error instanceof DeviceApiError) {
          if (error.status === 400) {
            await NotificationService.error(
              "ID perangkat atau password salah. Pastikan perangkat sudah terdaftar dan password benar.",
              "Gagal Menambah Perangkat"
            );
          } else {
            await NotificationService.error(
              error.message,
              "Gagal Menambah Perangkat"
            );
          }
        } else {
          await NotificationService.error(
            "Terjadi kesalahan saat menambahkan perangkat",
            "Gagal Menambah Perangkat"
          );
        }
      } finally {
        importing.value = false;
      }
    };

    const showInfo = async () => {
      const hasServerAccess = deviceApiService.hasAdminKey();

      await NotificationService.info(
        `
        <div class="text-start">
          <p><strong>Tentang Manajemen Perangkat IoT:</strong></p>
          <ul class="mb-3">
            <li><strong>Daftar Baru:</strong> Mendaftarkan perangkat IoT baru yang belum pernah terdaftar</li>
            <li><strong>Tambah yang Ada:</strong> Menambahkan perangkat yang sudah terdaftar sebelumnya ke manajemen</li>
            <li><strong>Test Koneksi:</strong> Memverifikasi koneksi ke perangkat IoT</li>
            <li><strong>Generate Stream Key:</strong> Membuat ulang kunci streaming untuk keamanan</li>
          </ul>
          
          <p><strong>Mode Operasi Saat Ini:</strong></p>
          <div class="alert ${
            hasServerAccess ? "alert-success" : "alert-warning"
          } p-2 mb-3">
            ${
              hasServerAccess
                ? '<i class="bi bi-cloud-check me-2"></i><strong>Server Connected:</strong> Semua operasi tersinkronisasi dengan server secara real-time.'
                : '<i class="bi bi-cloud-slash me-2"></i><strong>Local Mode:</strong> Operasi disimpan lokal di browser. Untuk akses server, hubungi administrator.'
            }
          </div>
          
          <p><strong>Catatan Penting:</strong></p>
          <ul>
            <li>Data perangkat disimpan secara lokal di browser Anda</li>
            <li>Simpan ID Perangkat dan Password dengan aman</li>
            <li>Stream Key diperlukan untuk streaming data dari perangkat</li>
            ${
              !hasServerAccess
                ? '<li class="text-warning"><strong>Mode Lokal:</strong> Perubahan edit/hapus hanya tersimpan di browser ini</li>'
                : '<li class="text-success"><strong>Mode Server:</strong> Semua perubahan tersinkronisasi dengan database server</li>'
            }
          </ul>
        </div>
      `,
        "Informasi Manajemen Perangkat"
      );
    };

    // --- Streaming / AI overlay toggles -----------------------------------
    const isTuyaDevice = (device: DeviceWithMetadata) =>
      !!device.tuya_device_id;

    // Player source for the watch modal, derived from the device's flags:
    // disconnected -> "off"; overlay off -> "direct" (raw Tuya); else "cv".
    // Active windows for the device currently being watched (WIB whole hours);
    // null = not loaded yet, [] = 24/7. Bumped `nowTick` re-evaluates the mode as
    // time crosses a window boundary mid-session.
    const watchWindows = ref<Array<{ start: number; end: number }> | null>(
      null
    );
    const nowTick = ref(0);
    let watchTickTimer: any = null;

    const parseWindows = (cfg: any): Array<{ start: number; end: number }> => {
      const aw = cfg?.active_windows;
      if (Array.isArray(aw) && aw.length) {
        const wins = aw
          .filter(
            (w: any) => Number.isFinite(+w?.start) && Number.isFinite(+w?.end)
          )
          .map((w: any) => ({ start: +w.start, end: +w.end }));
        if (wins.length) return wins;
      }
      const s = cfg?.active_hour_start;
      const e = cfg?.active_hour_end;
      if (s != null && e != null && s >= 0 && e >= 0 && +s !== +e) {
        return [{ start: +s * 60, end: +e * 60 }]; // legacy hours -> minutes
      }
      return []; // 24/7
    };

    const withinActiveWindowsNow = (
      wins: Array<{ start: number; end: number }> | null
    ): boolean => {
      if (!wins || !wins.length) return true; // 24/7
      const now = new Date();
      const m = ((now.getUTCHours() + 7) % 24) * 60 + now.getUTCMinutes(); // WIB minutes
      return wins.some(({ start, end }) =>
        start === end
          ? false
          : start < end
          ? m >= start && m < end
          : m >= start || m < end
      );
    };

    const watchPlayerMode = computed<"cv" | "direct" | "off">(() => {
      nowTick.value; // reactive dep so the mode re-evaluates each minute
      const d = watchingDevice.value;
      if (!d) return "cv";
      if (d.stream_enabled === false) return "off";
      if (d.cv_enabled === false) return "direct";
      // AI overlay only runs during active hours; outside the schedule the CV
      // pipeline is paused, so fall back to the raw Tuya feed (on-demand, SD).
      if (!withinActiveWindowsNow(watchWindows.value)) return "direct";
      return "cv";
    });

    // True only when we fell back to direct BECAUSE we're outside the schedule
    // (vs. the user having turned the AI overlay off) — used for the info text.
    const watchOutsideWindow = computed<boolean>(() => {
      nowTick.value;
      const d = watchingDevice.value;
      if (!d || d.stream_enabled === false || d.cv_enabled === false)
        return false;
      return !withinActiveWindowsNow(watchWindows.value);
    });

    // Schedule overlay (bottom-right of the live view) when a schedule exists.
    const watchScheduled = computed<boolean>(
      () => (watchWindows.value?.length ?? 0) > 0
    );
    const watchWithin = computed<boolean>(() => {
      nowTick.value;
      return withinActiveWindowsNow(watchWindows.value);
    });
    const _fmtMin = (m: number) => {
      const x = ((Math.round(m) % 1440) + 1440) % 1440;
      return `${String(Math.floor(x / 60)).padStart(2, "0")}:${String(
        x % 60
      ).padStart(2, "0")}`;
    };
    const watchScheduleLabel = computed<string>(() => {
      const w = watchWindows.value;
      if (!w || !w.length) return "";
      return w.map((x) => `${_fmtMin(x.start)}–${_fmtMin(x.end)}`).join(" · ");
    });

    // Master connect/disconnect. Disconnect stops all streaming (zero Tuya
    // quota); confirm before disconnecting since viewers lose the live feed.
    const toggleStream = async (device: DeviceWithMetadata) => {
      const next = !(device.stream_enabled !== false);
      if (!next) {
        const result = await NotificationService.confirm(
          `Siaran kamera "${DeviceHelpers.getDeviceDisplayName(
            device
          )}" akan diputus. Kamera berhenti streaming sepenuhnya (web & aplikasi) dan tidak memakai kuota Tuya. Lanjutkan?`,
          "Putuskan Siaran?",
          "Ya, Putuskan",
          "Batal"
        );
        if (!result.isConfirmed) return;
      }
      streamBusy.value = { ...streamBusy.value, [device.id]: true };
      const prev = device.stream_enabled;
      device.stream_enabled = next; // optimistic
      try {
        await deviceApiService.setStreamEnabled(device.id, next);
        await NotificationService.success(
          next ? "Siaran diaktifkan kembali." : "Siaran diputus (hemat kuota)."
        );
      } catch (e) {
        device.stream_enabled = prev; // rollback
        await NotificationService.error(
          e instanceof DeviceApiError
            ? e.message
            : "Gagal mengubah status siaran.",
          "Gagal"
        );
      } finally {
        streamBusy.value = { ...streamBusy.value, [device.id]: false };
      }
    };

    // AI overlay on/off. Off = raw feed direct from Tuya (needs a Tuya camera).
    const toggleCv = async (device: DeviceWithMetadata) => {
      if (!isTuyaDevice(device)) {
        await NotificationService.warning(
          "Hanya kamera Tuya yang dapat menampilkan siaran langsung tanpa overlay AI."
        );
        return;
      }
      const next = !(device.cv_enabled !== false);
      cvBusy.value = { ...cvBusy.value, [device.id]: true };
      const prev = device.cv_enabled;
      device.cv_enabled = next; // optimistic
      try {
        await deviceApiService.setCvEnabled(device.id, next);
        await NotificationService.success(
          next
            ? "Overlay AI diaktifkan."
            : "Overlay AI dimatikan — siaran langsung dari kamera."
        );
      } catch (e) {
        device.cv_enabled = prev; // rollback
        await NotificationService.error(
          e instanceof DeviceApiError
            ? e.message
            : "Gagal mengubah overlay AI.",
          "Gagal"
        );
      } finally {
        cvBusy.value = { ...cvBusy.value, [device.id]: false };
      }
    };

    // Initialize on component mount
    onMounted(async () => {
      setCurrentPageBreadcrumbs("Perangkat IoT", ["IoT"]);

      loading.value = true;
      try {
        await initialize();
        await loadBirdCounts();
      } finally {
        loading.value = false;
      }

      // Honor deep-links from Statistik IoT: ?edit=ID opens the edit modal,
      // ?highlight=ID filters to and highlights that device.
      const editId = route.query.edit ? String(route.query.edit) : null;
      const highlightId = route.query.highlight
        ? String(route.query.highlight)
        : null;

      if (editId) {
        const target = devices.value.find((d) => String(d.id) === editId);
        if (target) {
          editDevice(target);
        } else {
          await NotificationService.warning(
            `Perangkat #${editId} tidak ditemukan.`
          );
        }
      } else if (highlightId) {
        const target = devices.value.find((d) => String(d.id) === highlightId);
        if (target) {
          highlightedId.value = highlightId;
          // Ensure the row is visible regardless of pagination.
          searchQuery.value = highlightId;
          // Clear the highlight after a few seconds.
          setTimeout(() => {
            highlightedId.value = null;
          }, 4000);
        }
      }
    });

    return {
      // State
      devices,
      loading,
      submitting,
      deleting,
      searchQuery,
      currentPage,
      pageSize,
      viewingDevice,
      deviceToDelete,
      deviceForm,
      isEditing,
      sortField,
      sortOrder,
      importForm,
      importing,
      watchingDevice,
      watchActive,
      watchOutsideWindow,
      watchScheduled,
      watchWithin,
      watchScheduleLabel,
      watchPlayerMode,
      streamBusy,
      cvBusy,
      birdCounts,
      highlightedId,
      assigningDevice,
      assignEmail,
      assigning,
      shareEmail,
      sharingBusy,
      pairStep,
      pairSsid,
      pairPwd,
      pairName,
      pairLoading,
      pairError,
      pairQrValue,
      pairExpiryText,
      pairedDevice,

      // Computed
      filteredDevices,
      paginatedDevices,
      totalPages,
      deviceCount,
      onlineDevices,
      offlineDevices,

      // Methods
      refreshDevices,
      filterDevices,
      changePage,
      setSorting,
      formatDate,
      formatRelativeTime,
      maskStreamKey,
      copyStreamKey,
      getStatusBadgeClass,
      getStatusText,
      openAddDeviceModal,
      openImportDeviceModal,
      editDevice,
      viewDevice,
      watchDevice,
      openAssignOwner,
      submitAssignOwner,
      openHandoff,
      submitHandoff,
      handoffDevice,
      handoffEmail,
      handoffName,
      handoffLocation,
      handoffBusy,
      addShare,
      removeShare,
      openPairModal,
      generatePairing,
      finishPairing,
      submitDevice,
      handleRegenerateStreamKey,
      confirmResetBirdCount,
      confirmClearAllData,
      confirmDeleteDevice,
      handleDeleteDevice,
      handleTestConnection,
      importDevice,
      showInfo,
      exportToCSV,
      isTuyaDevice,
      toggleStream,
      toggleCv,

      // API Service reference for template
      deviceApiService,
    };
  },
});
</script>

<style scoped>
.table th {
  border-top: none;
}

.symbol-label {
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  border-radius: 0.75rem;
}

.card {
  border-radius: 0.75rem;
}

.btn {
  border-radius: 0.5rem;
}

.form-control {
  border-radius: 0.5rem;
}

.form-select {
  border-radius: 0.5rem;
}

.badge {
  padding: 0.5rem 0.75rem;
  border-radius: 0.5rem;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
}

/* Custom scrollbar for modal */
.modal-body {
  max-height: 70vh;
  overflow-y: auto;
}

.modal-body::-webkit-scrollbar {
  width: 6px;
}

.modal-body::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.modal-body::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.modal-body::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Responsive table */
@media (max-width: 768px) {
  .table-responsive {
    font-size: 0.875rem;
  }

  .btn-sm {
    padding: 0.25rem 0.5rem;
    font-size: 0.75rem;
  }

  .symbol-circle {
    width: 35px !important;
    height: 35px !important;
  }
}

/* Animation for loading spinner */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.spinner-border {
  animation: spin 1s linear infinite;
}

/* Custom success/error colors */
.text-success {
  color: #50cd89 !important;
}

.text-danger {
  color: #f1416c !important;
}

.text-warning {
  color: #ffc700 !important;
}

.text-info {
  color: #7239ea !important;
}

/* Button hover effects */
.btn:hover {
  transform: translateY(-1px);
  transition: all 0.2s ease-in-out;
}

.btn:active {
  transform: translateY(0);
}

/* Card hover effect */
.card:hover {
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease-in-out;
}

/* Form focus states */
.form-control:focus {
  border-color: #009ef7;
  box-shadow: 0 0 0 0.2rem rgba(0, 158, 247, 0.25);
}

/* Modal backdrop */
.modal-backdrop {
  background-color: rgba(0, 0, 0, 0.5);
}

/* Table hover effect */
.table-hover tbody tr:hover {
  background-color: rgba(0, 158, 247, 0.05);
}

/* Deep-link highlighted row (from Statistik IoT) */
.highlighted-row > td {
  background-color: rgba(0, 158, 247, 0.12) !important;
  animation: highlightFade 4s ease-out forwards;
}

@keyframes highlightFade {
  0% {
    background-color: rgba(0, 158, 247, 0.3);
  }
  100% {
    background-color: rgba(0, 158, 247, 0);
  }
}

/* Pagination */
.pagination .page-link {
  border-radius: 0.5rem;
  margin: 0 0.25rem;
  border: none;
  color: #5e6278;
}

.pagination .page-link:hover {
  background-color: #f5f8fa;
  color: #009ef7;
}

.pagination .page-item.active .page-link {
  background-color: #009ef7;
  border-color: #009ef7;
}

/* Status indicators */
.badge-light-success {
  background-color: rgba(80, 205, 137, 0.1);
  color: #50cd89;
}

.badge-light-danger {
  background-color: rgba(241, 65, 108, 0.1);
  color: #f1416c;
}

.badge-light-warning {
  background-color: rgba(255, 199, 0, 0.1);
  color: #ffc700;
}

.badge-light-info {
  background-color: rgba(114, 57, 234, 0.1);
  color: #7239ea;
}

.badge-light-primary {
  background-color: rgba(0, 158, 247, 0.1);
  color: #009ef7;
}

.badge-light-secondary {
  background-color: rgba(99, 115, 129, 0.1);
  color: #637381;
}

/* Background color mappings for status icons */
.bg-badge-light-success {
  background-color: #50cd89 !important;
}

.bg-badge-light-danger {
  background-color: #f1416c !important;
}

.bg-badge-light-warning {
  background-color: #ffc700 !important;
}

/* Device status specific styles */
.device-status-online {
  color: #50cd89;
}

.device-status-offline {
  color: #f1416c;
}

.device-status-unknown {
  color: #ffc700;
}

/* Stream key display */
.stream-key-display {
  font-family: "Courier New", monospace;
  background-color: #f8f9fa;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 0.9em;
}

/* Action buttons container */
.action-buttons {
  white-space: nowrap;
}

.action-buttons .btn {
  margin-left: 0.25rem;
}

.action-buttons .btn:first-child {
  margin-left: 0;
}

/* Loading states */
.loading-overlay {
  position: relative;
}

.loading-overlay::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Mobile optimizations */
@media (max-width: 576px) {
  .card-toolbar .btn {
    width: 100%;
    margin-bottom: 0.5rem;
  }

  .action-buttons {
    display: flex;
    flex-wrap: wrap;
    gap: 0.25rem;
  }

  .action-buttons .btn {
    flex: 1;
    min-width: 36px;
    margin: 0;
  }

  .table-responsive {
    font-size: 0.8rem;
  }

  .modal-dialog {
    margin: 0.5rem;
  }
}

/* Print styles */
@media print {
  .btn,
  .pagination,
  .modal {
    display: none !important;
  }

  .card {
    border: 1px solid #ddd;
    box-shadow: none;
  }

  .table {
    font-size: 0.8rem;
  }
}

/* High contrast mode support */
@media (prefers-contrast: high) {
  .badge {
    border: 1px solid currentColor;
  }

  .btn {
    border: 2px solid currentColor;
  }
}

/* Reduced motion support */
@media (prefers-reduced-motion: reduce) {
  .btn,
  .card,
  * {
    transition: none !important;
    animation: none !important;
  }
}

/* SweetAlert2 z-index fix for Bootstrap modals */
.swal2-container {
  z-index: 9999 !important;
}

.swal2-popup {
  z-index: 10000 !important;
}

/* Ensure SweetAlert2 backdrop is above Bootstrap modals */
.swal2-backdrop-show {
  z-index: 9998 !important;
}

/* Bootstrap modal backdrop adjustment */
.modal-backdrop {
  z-index: 1055;
}

.modal {
  z-index: 1056;
}
</style>
